// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zObaWRTvOnF4KXYeQPaG{max-width:750px}`, "",{"version":3,"sources":["webpack://./src/components/settings/views/single-sign-on-settings/single-sign-on-settings-form/single-sign-on-settings-form.scss"],"names":[],"mappings":"AAAA,sBACI,eAAA","sourcesContent":[".formContent {\n    max-width: 750px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContent": `zObaWRTvOnF4KXYeQPaG`
};
export default ___CSS_LOADER_EXPORT___;
